// AI Generated Component
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { MonDialog } from '@client/app/modules/dialog-upgrade-wrapper/mon-dialog.service';
import { FormLabelComponent } from '@client/app/forms/label/label.component';
import { LabelTableService } from '@client/app/services/label-table/label-table.service';

@Component({
    selector: 'label-container-selector',
    template: `
        <div class="label-selector"
             (clickOutside)="setMonShow(false)"
             clickOutsideExclude=".label-container"
             [ngClass]="{'d-block': monShow, 'd-none': !monShow}"
             (click)="$event.stopPropagation()">
            <ul>
                <li class="label-search-box">
                    <label [for]="'label-container-search-' + randomId"
                           class="sr-only"
                           translate>
                        Search label
                    </label>
                    <input type="search"
                           [(ngModel)]="search"
                           [name]="'search'"
                           [id]="'label-container-search-' + randomId"
                           [attr.aria-describedby]="'label-container-search-describe-' + randomId">
                    <span [id]="'label-container-search-describe-' + randomId" class="sr-only" translate>
                        Filter labels list
                    </span>
                </li>
                <li class="clear-label" (click)="clearLabel()">
                    <div class="indicators">
                        <span class="indicator fas fa-times" aria-hidden="true"></span>
                    </div>
                    <div class="label-name" translate>Clear all labels</div>
                </li>
                <li class="clear-label" (click)="openLabelForm()" *ngIf="canManageLabels">
                    <span class="label-name text-link cursor-pointer">
                        <span class="fas fa-plus" aria-hidden="true"></span>
                        <span translate>Add new label</span>
                    </span>
                </li>
                <li *ngFor="let option of filteredLabels; trackBy: trackByIndex"
                    role="menuitemcheckbox"
                    [attr.aria-checked]="hasLabel(option)"
                    [value]="option"
                    (click)="updateLabel(option)">
                    <div class="indicators" [ngClass]="{'active': hasLabel(option)}" aria-hidden="true">
                        <span class="indicator selected fas fa-check"></span>
                        <span class="indicator remove fas fa-times"></span>
                    </div>
                    <div aria-hidden="true" class="label-color-box" [ngStyle]="{'background-color': option.color}"></div>
                    <div class="label-name">{{option.name}}</div>
                </li>
            </ul>
        </div>
    `,
    standalone: false,
})
export class LabelContainerSelectorComponent implements OnInit {
    @Input() monShow: boolean = false;
    @Input() currentLabels: any[] = [];
    @Input() allLabels: any[] = [];
    @Output() onUpdateLabel = new EventEmitter<void>();
    @Output() getLabels = new EventEmitter<void>();

    @Output() monShowChange = new EventEmitter<boolean>();

    randomId: string = '';
    search: string = '';
    public canManageLabels: boolean;

    constructor (
        private monDialog: MonDialog,
        private translateService: TranslateService,
        private labelTableService: LabelTableService,
    ) {
        this.canManageLabels = this.labelTableService.canManageLabels;
    }

    ngOnInit (): void {
        this.activate();
    }

    get filteredLabels (): any[] {
        if (!this.search || this.search.trim() === '') {
            return this.allLabels || [];
        }
        return (this.allLabels || []).filter(label =>
            label.name && label.name.toLowerCase().includes(this.search.toLowerCase()),
        );
    }

    trackByIndex (index: number, item: any): number {
        return index;
    }

    setMonShow (val: boolean): void {
        this.monShow = val;
        this.monShowChange.emit(this.monShow);
    }

    private activate (): void {
        this.randomId = this.guidGenerator();
        this.search = '';
    }

    hasLabel (option: any): boolean {
        return Array.isArray(this.currentLabels) &&
            this.currentLabels.length > 0 &&
            this.currentLabels.some(label => label.id === option.id);
    }

    updateLabel (label: any): void {
        if (this.currentLabels.length > 0 && this.hasLabel(label)) {
            this.currentLabels.splice(this.labelIndex(label), 1);
        } else {
            this.currentLabels.push(label);
        }
        this.onUpdateLabel.emit();
    }

    clearLabel (): void {
        this.currentLabels.length = 0;
        this.onUpdateLabel.emit();
    }

    openLabelForm (): void {
        const params = {
            body: FormLabelComponent,
            size: 'xs',
            classes: 'fade-animation middle center label-dialog',
        };
        this.monDialog.create(params, (label: any) => {
            if (typeof this.getLabels.emit === 'function') {
                this.getLabels.emit();
            }
            if (label && label.id) {
                this.updateLabel(label);
            }
        }, null);
    }

    private guidGenerator (): string {
        const S4 = () => {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        };
        return (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4());
    }

    private labelIndex (selectedLabel: any): number {
        for (let i = 0; i < this.currentLabels.length; i++) {
            if (selectedLabel.id === this.currentLabels[i].id) {
                return i;
            }
        }
        return -1;
    }
}
